import axios from "axios";
import Toast from "./Toast";
import { postRequest } from "../api/apiServices";
import apiList from "../api/apiList";


export const generateText = async (prompt, assistantId, threadId) => {
  // Handling Guards
  if (!prompt || typeof prompt !== "string" || prompt.trim().length === 0) {
    Toast("Please enter some details...!", "error");
    return "";
  }

  if (!assistantId || !threadId) {
    Toast("Assistant ID or Thread ID is missing!", "error");
    return "";
  }
  try {
    const payload = { prompt, assistantId, threadId };
    const response = await postRequest(apiList.generateText, payload);

    const res = response?.data;
    const data = res?.data ?? res;

    let textCandidate =
      (typeof data === "string" ? data : "") ||
      data?.text ||
      data?.message ||
      data?.result ||
      data?.content ||
      res?.choices?.[0]?.message?.content ||
      res?.data?.choices?.[0]?.message?.content ||
      "";

    if (typeof textCandidate === "string") {
      const trimmed = textCandidate.trim();
      if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
        try {
          textCandidate = JSON.parse(trimmed);
        } catch {
          textCandidate = trimmed.slice(1, -1);
        }
      }
    }

    return String(textCandidate || "").trim();
  } catch (error) {
    console.error("Error calling backend generate-text API:", error);
    return "";
  }
};

export const generateTextObject = async (questionsAndKeywords) => {
  // Guard clause: must be a non-null object
  if (!questionsAndKeywords || typeof questionsAndKeywords !== "object") {
    Toast("Invalid input. Please provide an object.", "warning");
    return;
  }

  try {
    const payload = { prompt: questionsAndKeywords };
    const response = await postRequest(apiList.generateTextObject, payload);

    // Normalize common shapes
    const res = response?.data;
    const data = res?.data ?? res;

    if (data && typeof data === "object") return data;

    Toast("No data returned from the server.", "warning");
    return {};
  } catch (error) {
    console.error("Error calling backend generate-text-object API:", error);
    throw new Error("Failed to generate text object");
  }
};

export const generateTexts = async (keywords) => {
  // Handling Gaurd's
  if (
    !keywords ||
    typeof keywords !== "string" ||
    keywords.trim().length === 0
  ) {
    Toast("Please enter some details...!", "error");
    return "";
  }
  try {
    const payload = { prompt: keywords };
    const response = await postRequest(apiList.generateTexts, payload);

    const res = response?.data;
    const data = res?.data ?? res;

    let textCandidate =
      (typeof data === "string" ? data : "") ||
      data?.text ||
      data?.message ||
      data?.result ||
      data?.content ||
      res?.choices?.[0]?.message?.content ||
      res?.data?.choices?.[0]?.message?.content ||
      "";

    if (typeof textCandidate === "string") {
      const trimmed = textCandidate.trim();
      if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
        try {
          textCandidate = JSON.parse(trimmed);
        } catch {
          textCandidate = trimmed.slice(1, -1);
        }
      }
    }

    return String(textCandidate).trim();
  } catch (error) {
    console.error("Error calling backend generate-texts API:", error);
    return "";
  }
};
